import { render, staticRenderFns } from "./storeSpareIndex.vue?vue&type=template&id=8153a59c&scoped=true"
import script from "./storeSpareIndex.vue?vue&type=script&lang=js"
export * from "./storeSpareIndex.vue?vue&type=script&lang=js"
import style0 from "./storeSpareIndex.vue?vue&type=style&index=0&id=8153a59c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8153a59c",
  null
  
)

export default component.exports